<template>
  <div class="relative w-72">
    <button
      @click="isOpen = !isOpen"
      id="dropdownButton"
      data-dropdown-toggle="dropdown-content"
      class="flex justify-between items-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none"
      type="button"
    >
      <div class="flex flex-col text-left">
        <span class="font-medium">Exercice {{ selected.label }}</span>
        <span class="text-xs text-gray-500">{{ selected.period }}</span>
      </div>
      <svg class="w-4 h-4 ml-2" aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div v-if="isOpen" id="dropdown-content" class="z-10 absolute top-full mt-1 w-full bg-white divide-y divide-gray-100 rounded-lg shadow border border-gray-200">
      <ul class="py-2 text-sm text-gray-700" aria-labelledby="dropdownButton">
        <li v-for="exercise in exercises" :key="exercise.label">
          <button @click="select(exercise)" class="flex flex-col w-full text-left px-4 py-2 hover:bg-gray-100" :class="{ 'bg-gray-100 font-medium': selected.label === exercise.label }">
            <span>Exercice {{ exercise.label }}</span>
            <span class="text-xs text-gray-500">{{ exercise.period }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentDropdowns",
          props: {
            id: String,
            label: String,
            index: String,
            required: Boolean,
            config: {},
        },
        emits: [ "valueChanged" ],
  data() {
    return {
      isOpen: false,
      selected: {
        label: "2025-2026",
        period: "01 juil. 2025 - 30 juin 2026", "started_at": "2025-07-01", "ended_at": "2026-06-30" ,
      },
      exercises: [
        { label: "2025-2026", period: "01 juil. 2025 - 30 juin 2025", "started_at": "2025-07-01", "ended_at": "2026-06-30" },
        { label: "2024-2025", period: "01 juil. 2024 - 30 juin 2024", "started_at": "2024-07-01", "ended_at": "2025-06-30" },
        { label: "2023-2024", period: "01 juil. 2023 - 30 juin 2023" , "started_at": "2023-07-01", "ended_at": "2024-06-30"}
      ],
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(exercise) {
       
      this.selected = exercise;
      this.isOpen = false;
      this.$emit("valueChanged", exercise); // si tu veux écouter dans le parent
    },
  },
};
/*

    import common_labels from "@/assets/lg/common.json"


    export default {
        name: 'ContentButton',
        components: {},
        props: {
            id: String,
            label: String,
            index: String,
            required: Boolean,
            config: {},
        },
        emits: ["updateField", "valueChanged", "manageField"],
        data() {
            return {
                output: "",
                lg: "FR",
                labels: common_labels,
                common_labels: common_labels,
            }
        },

        computed:
        {
            'icon_button': function () { return  this.config?.icon ? this.config?.icon : 'fa-plus ' }
        },
        watch: {
            value: async function (val) {
                if (val != undefined) {
                    this.output = this.value;
                }
            }
        },
        async mounted() {
            this.output = this.value
        },

        methods: {
            onClick : function()
            {
                
                let event = {
                    type: this.config?.action,
                    email: ''
                }
                this.$emit("action", event)
            }
           
        }
    }
        */
 
</script>
